import React from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "../../providers/AuthProvider";

export function RequireAuth({ children }: { children?: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return null;
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (children) return <>{children}</>;
  return <Outlet />;
}

